var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Outline/bell"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M17.4998 19.8333H23.3332L21.6941 18.1942C21.2496 17.7497 20.9998 17.1468 20.9998 16.5182V12.8333C20.9998 9.78549 19.052 7.1926 16.3332 6.23165V5.83333C16.3332 4.54467 15.2885 3.5 13.9998 3.5C12.7112 3.5 11.6665 4.54467 11.6665 5.83333V6.23165C8.94772 7.1926 6.99984 9.78549 6.99984 12.8333V16.5182C6.99984 17.1468 6.75011 17.7497 6.30559 18.1942L4.6665 19.8333H10.4998M17.4998 19.8333V21C17.4998 22.933 15.9328 24.5 13.9998 24.5C12.0668 24.5 10.4998 22.933 10.4998 21V19.8333M17.4998 19.8333H10.4998",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.efba32db88f0a9769511330d776acccc.svg";
export { ForwardRef as ReactComponent };